import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import UserIncomeRowsTableRow from './UserIncomeRowsTableRow';
import type { UserIncomeReportItemType } from '@econtractor/types';

interface UserIncomeRowsTableBodyProps {
    rows: UserIncomeReportItemType[];
}

const UserIncomeRowsTableBody = ({ rows }: UserIncomeRowsTableBodyProps) => {
    const { t } = useTranslation(['Reports']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={4} className="text-center text-muted py-3">
                    {t('usersFields.emptyRows')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row, index) => (
                <UserIncomeRowsTableRow
                    key={`${row.incomeId}-${row.objectId}-${index}`}
                    row={row}
                />
            ))}
        </tbody>
    );
};

export default UserIncomeRowsTableBody;
